module.exports = __webpack_public_path__ + "img/eeab6d7.png";